/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore'
], (
	_
) => {

	return class VisMapColumnsToSlot {
		constructor(options = {}) {
			this.content = options.content;
			this.visualization = options.visualization;
			this.slots = this.visualization.getSlots();
			this.transaction = options.transaction;
		}

		mapColumns (slotId, droppedColumns, options = {}, transactionToken) {
			const columns = droppedColumns;
			let metadataColumns = _.pluck(droppedColumns, 'metadataColumn');
			const originalMetadataColumns = _.chain(droppedColumns).pluck('original').compact().pluck('metadataColumn').value();
			const slot = this.slots.getSlot(slotId);
			if (slot) {
				const { position, bReplace, activeDataSourceId } = options;
				const canSetLocalFilters = _.isBoolean(options.canSetLocalFilters) ? options.canSetLocalFilters : true;
				const slotDataItemList = slot.getDataItemList();
				const localFilters = this.visualization.getLocalFilters();
				const subTransactionToken = this.transaction.startTransaction(transactionToken);
				// before add data items, ensure the visulization datasource is set. Could fail 
				// in certain conditions, for example if the visualization don't support the datasource.
				this._setDataSource(metadataColumns, subTransactionToken, activeDataSourceId);
				if(this.visualization.getDataSource() === null){
					this.transaction.endTransaction(subTransactionToken);
					return;
				}

				if (bReplace && slotDataItemList.length) {
					//Delete local filters associated with this data item so that it will get added to undo/redo stack
					const filterKey = { itemId: slotDataItemList[position].getColumnId() };
					if (localFilters.filterExists(filterKey)) {
						localFilters.removeFilter(filterKey, subTransactionToken);
					}
					const ids = [slotDataItemList[position].getId()];
					slot.removeDataItems(ids, subTransactionToken);
					if(this.visualization.getDataSource() === null){
						this._setDataSource(metadataColumns, subTransactionToken, activeDataSourceId);
					}
				}

				const localFltersSpec = [];
				if (canSetLocalFilters) {
					const result = this._getLocalFilters({
						slot: slot,
						columns: columns,
						bReplace: bReplace
					}, subTransactionToken);

					localFltersSpec.push(...result);
				}

				metadataColumns = _.pluck(columns, 'metadataColumn');
				const columnSpecs = _.map(metadataColumns, (metadataColumn) => { return { columnId: metadataColumn.getId() }; });
				if (columnSpecs.length) {
					const dataItemList = slot.addDataItems(columnSpecs, position, subTransactionToken);
					let items = originalMetadataColumns;
					items && items.forEach((item, index) => {
						let navPathId = item.getParent() ? item.getParent().getId() : null;

						if (navPathId && item.getParent().getObjectType().toLowerCase() === 'drillgroup') {
							dataItemList[index].setNavigationPathId(navPathId, subTransactionToken);
						}
					});
				}

				const dataItemList = slot.getDataItemList();
				localFltersSpec.forEach(spec => {
					//if dataItem is added to slot or visualization, then add filters,
					// if dataItem is not added due to any reason, do not add filters
					let dataItem = dataItemList.find(dataItem => dataItem.getColumnId() === spec.itemContext.itemId) || null;
					if (dataItem) {
						if (spec.hasFilters) {
							localFilters.editFilter(spec.itemContext, spec.filterContext, subTransactionToken);
						} else {
							localFilters.addFilter(spec.itemContext, spec.filterContext, subTransactionToken);
						}
					}
				});

				this.transaction.endTransaction(subTransactionToken);
			}
		}

		_setDataSource(metadataColumns, transactionToken, activeDataSourceId) {
			let sourceId = activeDataSourceId;
			if (!sourceId && metadataColumns.length > 0) {
				const firstMetadataColumn = metadataColumns[0];
				sourceId = firstMetadataColumn.getSourceId();
			}
			this.visualization.setDataSource(sourceId, transactionToken);
		}

		_getLocalFilters(context = {}, transactionToken) {
			return this.content.getFeature('VisDnD.utils').addMembersAsLocalFilters({
				slotAPI: context.slot,
				doUpdateFilters: false,
				columns: context.columns,
				bReplace: context.bReplace
			}, transactionToken);
		}
	};
});
